// ─── Document Chat ────
export const DOCUMENT_CHAT_STORAGE_KEY = "dc_sessions";
export const ACTIVE_CHAT_KEY = "dc_active_chat";

// ─── Contract Analysis ────
export const CONTRACT_ANALYSIS_SESSIONS_KEY = "ca_sessions";
export const CONTRACT_ANALYSIS_ACTIVE_SESSION_KEY = "ca_active_session";

// ─── Document Analysis ────
export const DOCUMENT_ANALYSIS_SESSIONS_KEY = "doca_sessions";
export const DOCUMENT_ANALYSIS_ACTIVE_SESSION_KEY = "doca_active_session";

export const USER_INFO_KEY = "userInfo";


